import { useCallback } from 'react';

import { notNullOrUndefined } from 'constants/helper';

import useLocalStorage from './useLocalStorage';

export const useAgGridPersistExpandOrCollapseAll = ({ key, gridRef }) => {
  const [persistedGridState, setPersistedGridState] = useLocalStorage(key, null);

  const persistedExpandOrCollapseAllState = persistedGridState?.expandAll;

  const saveExpandOrCollapseAllState = useCallback(
    (isExpandAll) => {
      setPersistedGridState((prev) => ({ ...prev, expandAll: isExpandAll }));
    },
    [setPersistedGridState]
  );

  const loadExpandedCollapseAllState = useCallback(() => {
    /* Read from localStorage */
    if (notNullOrUndefined(persistedExpandOrCollapseAllState)) {
      if (persistedExpandOrCollapseAllState) {
        gridRef?.current?.api?.expandAll();
      } else {
        gridRef?.current?.api?.collapseAll();
      }
    }
  }, [persistedExpandOrCollapseAllState, gridRef]);

  return {
    persistedExpandOrCollapseAllState,
    saveExpandOrCollapseAllState,
    loadExpandedCollapseAllState,
  };
};
